const {wrapPageElement} = require("./utils/wrap-page-element")

exports.wrapPageElement = wrapPageElement
